// extracted by mini-css-extract-plugin
export default {"table":"bad881fb03dd"};